<template>
  <div>
    <!-- ローディング -->
    <DialogLoading ref="DialogLoading" />

    <!-- 類似券面複数利用制限のダイアログ -->
    <DialogAlreadyValidatedAnother ref="DialogAlreadyValidatedAnother" />

    <!-- 同一券面複数利用制限のダイアログ -->
    <DialogMaxConcurrentUsingOver ref="DialogMaxConcurrentUsingOver" />
  </div>
</template>

<script>
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";
import DialogAlreadyValidatedAnother from "@/views/Components/Organisms/MyTickets/Dialog/DialogAlreadyValidatedAnother";
import DialogMaxConcurrentUsingOver from "@/views/Components/Organisms/MyTickets/Dialog/DialogMaxConcurrentUsingOver";

import { onMounted, computed, watch, watchEffect, ref } from "vue";

export default {
  name: "ThePassDialogs",
  props: {
    DialogAction: {
      type: Object,
    },
  },
  setup(props) {
    const DialogLoading = ref(null);
    const DialogAlreadyValidatedAnother = ref(null);
    const DialogMaxConcurrentUsingOver = ref(null);

    watch(
      () => props.DialogAction,
      (DialogAction) => {
        console.log("DialogAction :>> ", DialogAction);
        if (DialogAction.action) {
          eval(DialogAction.dialog).value.openDialog();
        } else {
          eval(DialogAction.dialog).value.closeDialog();
        }
      }
    );

    return {
      DialogLoading,
      DialogAlreadyValidatedAnother,
      DialogMaxConcurrentUsingOver,
    };
  },
};
</script>
